var _path, _mask, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.155 17.1952C24.155 21.4658 20.7986 24.9021 16.6895 24.9021C12.5804 24.9021 9.224 21.4658 9.224 17.1952C9.224 12.9247 12.5804 9.48837 16.6895 9.48837C20.7986 9.48837 24.155 12.9247 24.155 17.1952Z",
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_335_2745",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5552 21.2226C11.6858 20.2752 11.1478 19.056 11.0263 17.7582C10.9048 16.4603 11.2067 15.1577 11.8844 14.0565C12.562 12.9552 13.5767 12.1182 14.7679 11.6778C15.9591 11.2374 17.2588 11.2188 18.4614 11.6248L18.2031 12.4371C17.1758 12.0902 16.0656 12.1062 15.0481 12.4824C14.0306 12.8585 13.1639 13.5735 12.5851 14.5142C12.0062 15.4548 11.7483 16.5675 11.8521 17.6761C11.9559 18.7847 12.4154 19.8261 13.1581 20.6354L12.5552 21.2226Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5552 21.2226C11.6858 20.2752 11.1478 19.056 11.0263 17.7582C10.9048 16.4603 11.2067 15.1577 11.8844 14.0565C12.562 12.9552 13.5767 12.1182 14.7679 11.6778C15.9591 11.2374 17.2588 11.2188 18.4614 11.6248L18.2031 12.4371C17.1758 12.0902 16.0656 12.1062 15.0481 12.4824C14.0306 12.8585 13.1639 13.5735 12.5851 14.5142C12.0062 15.4548 11.7483 16.5675 11.8521 17.6761C11.9559 18.7847 12.4154 19.8261 13.1581 20.6354L12.5552 21.2226Z",
    stroke: "#FF6E04",
    strokeWidth: 2,
    strokeLinecap: "round",
    mask: "url(#path-2-inside-1_335_2745)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.0002,
    y1: 3.79877,
    x2: 16.0002,
    y2: 0.499934,
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.0002,
    y1: 33.4998,
    x2: 16.0002,
    y2: 30.2009,
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3275,
    y1: 16.4999,
    x2: 32.4999,
    y2: 16.4999,
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 16.4999,
    x2: 3.6724,
    y2: 16.4999,
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 3.73609,
    y2: -0.5,
    transform: "matrix(0.696475 -0.717581 0.696475 0.717581 25.2169 8.01871)",
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 3.73609,
    y2: -0.5,
    transform: "matrix(0.696475 -0.717581 0.696475 0.717581 4.83295 29.0207)",
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 3.73609,
    y2: -0.5,
    transform: "matrix(0.696475 0.717581 -0.696475 0.717581 25.2169 25.9811)",
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 3.73609,
    y2: -0.5,
    transform: "matrix(0.696475 0.717581 -0.696475 0.717581 4.83295 4.97919)",
    stroke: "#FF6E04",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.c0ffa7fd71ab6247adf87465f4da3ec0.svg";
export { ForwardRef as ReactComponent };